import { ReactNode, useEffect, useState } from "react"
import { useNavigate, useSearchParams } from "react-router-dom"
import { DataTable, DataTablePageParams, DataTableRowClickEventParams } from "primereact/datatable"
import { Column } from "primereact/column"
import { Button } from "primereact/button"
import { createUrlParams } from "../../../api/client"
import { useAddresses } from "../../../api/queries/useAddresses"
import { Address } from "../../../api/types/address"
import { storage } from "../../../common/storage"
import { countryColumnTemplate } from "../../common/country"

export default function AddressList() {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()

  const rowClassName = (address: Address) => ({
    "cursor-pointer": true,
  })

  const offsetParam: string = searchParams.get("offset") || ""
  const limitParam: string = searchParams.get("limit") || ""
  const [offset, setOffset] = useState<number>(parseInt(offsetParam) || 0)
  const [limit, setLimit] = useState<number>(parseInt(limitParam) || storage.get("limit") || 20)

  const { data: addresses, isLoading } = useAddresses({
    limit,
    offset,
  })

  useEffect(() => {
    navigate({
      search: createUrlParams({ limit, offset }),
    }, {
      replace: true,
    })
  }, [limit, offset, navigate])

  const onPage = ({ first, rows }: DataTablePageParams): void => {
    setOffset(first)
    setLimit(rows)
    storage.set("limit", rows)
  }

  const handleNewUserClick = () => navigate("/addresses/new")

  const handleRowClick = (row: DataTableRowClickEventParams) => {
    navigate(`/addresses/${row.data.uuid}`)
  }

  const tName = (row: Address): string => row.name

  const tStreet = (row: Address): string => row.street

  const tStreetDetails = (row: Address): string => row.streetDetails || ""

  const tCity = (row: Address): string => row.city
  
  const tCountry = (row: Address): ReactNode => countryColumnTemplate(row.country)

  const tIsMain = (row: Address): ReactNode =>
    <i className={`pi pi-${row.isMain ? "check" : "times"}`} />

  return (
    <>
      <div className={"col-12"}>
        <Button label={"Nová pobočka"} icon={"pi pi-plus"} onClick={handleNewUserClick}
          className={"p-button p-button-primary p-button-sm"} />
      </div>

      <div className={"col-12"}>
        <DataTable
          emptyMessage={"Žádné záznamy"} className={"p-datatable-sm"}
          paginator={true} lazy={true} rows={limit} first={offset}
          totalRecords={addresses?.results.totalCount}
          loading={isLoading} onPage={onPage} value={addresses?.results.addressList}
          onRowClick={handleRowClick} rowClassName={rowClassName} rowHover={true} stripedRows={true}
          paginatorTemplate={"FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"}
          rowsPerPageOptions={[20, 50, 100]}
          // filterDisplay={"row"}
          >

          <Column header={"Název"} body={tName} />

          <Column header={"Upřesnění"} body={tStreetDetails} />

          <Column header={"Ulice"} body={tStreet} />

          <Column header={"Město"} body={tCity} />

          <Column header={"Stát"} body={tCountry} />

          <Column header={"Centrála"} body={tIsMain} />

        </DataTable>
      </div>
    </>
  )
}
